import React from "react";
import {
  BrowserRouter as Router,
  useLocation,
  useRoutes,
} from "react-router-dom";
import AboutUs from "./pages/AboutUs";
import Faqs from "./pages/Faqs";
import Termsofuse from "./pages/Termsofuse";
import ContactUs from "./pages/ContactUs";
import { useEffect } from "react";
import ScrollToTop from "./ScrollToTop";
import { useState } from "react";
import Preloader from "./components/preloader";
import SignUp from "./khojpages/signUp";
import useLocalStorage from "use-local-storage";
import Notification from "./khojpages/NoticationPage/Notification";
import ForgotPassword from "./khojpages/Forget Password/ForgotPassword";
import Login from "./khojpages/Login/Login";
import RestoreAccount from "./khojpages/RestoreAccount/RestoreAccount";
import ManageProfile from "./khojpages/ManageProfile/ManageProfile";
import ViewProfile from "./khojpages/ViewProfile/ViewProfile";
import ApprovalProcess from "./khojpages/ApprovalProcess/ApprovalProcess";
import BulkProfileResume from "./khojpages/BulkProfile-Resume/BulkProfileResume";
import ManageJobs from "./khojpages/ManageJobs/ManageJobs";
import PostJobs from "./khojpages/PostJobs/PostJobs";
import OfferedJobs from "./khojpages/OfferedJobs/OfferedJobs";
import SavedJobs from "./khojpages/SavedJobs/SavedJobs";
import AppliedJobs from "./khojpages/AppliedJobs/AppliedJobs";
import RecommendationJobs from "./khojpages/RecommendationJobs/RecommendationJobs";
import InterviewAndSchedule from "./khojpages/InterviewSchedule/InterviewAndSchedule";
import FollowedCompanies from "./khojpages/FollowedCompanies/FollowedCompanies";
import Settings from "./khojpages/Settings/Settings";
import DeleteProfile from "./khojpages/DeleteProfile/DeleteProfile";
import ChangePassword from "./khojpages/ChangePassword/ChangePassword";
import AlertJobs from "./khojpages/AlertJobs/AlertJobs";
import ManageBatch from "./khojpages/ManageBatch/ManageBatch";

import Searchjobs from "./khojpages/Searchjob/Searchjobs";
import JobApplications from "./khojpages/ManageApplications/ManageApplications";
import EditProfiles from "./khojpages/EditProfile/EditProfile";
import PeopleSearch from "./khojpages/PeopleSearch/PeopleSearch";
import BlockCompanies from "./khojpages/BlockCompany/BlockCompanies";
import InstituteProfile from "./khojpages/InstituteProfile/InstituteProfile";
import ViewJobs from "./khojpages/ViewJobs/ViewJobs";
import ApplicantJobs from "./khojpages/ApplicantJobs/ApplicantJobs";
import AlertCandidates from "./khojpages/AlertCandidates/AlertCandidates";
import ConfirmPassword from "./khojpages/Forget Password/ConfirmPassword";
import PrivateRoute from "./PrivateRouter";
import UserProfile from "./khojpages/PeopleSearch/UserProfile";
import EditJobs from "./khojpages/EditJob/EditJobs";
import CompanyList from "./khojpages/PostJobs/Companies/CompanyList";
import Institute from "./khojpages/Institute/Institute";
import InsititutePage from "./khojpages/TopInstitute/InsititutePage";
import CompanyDetailMain from "./khojpages/PostJobs/Companies/CompanyDetailMain";
import Candidate from "./khojpages/ViewProfile/Candidate";
import UpdateCandidatemain from "./khojpages/UpdateCandidatebyInstitute/UpdateCandidatemain";
import Resume from "./khojpages/Resume/Resume";
import CandidResume from "./khojpages/ViewProfile/CandidResume";
import Home from "./khojpages/Mainhome/Home";
import NotFound from "./khojpages/NotFound";
import ManageCompanies from "./khojpages/PostJobs/Companies/ManageCompanies";
import PrivacyPolicy from "./khojpages/PrivacyPolicy";
import Editjob from "./khojpages/EditJob/Editjob";
import RecruiterDetailMain from "./khojpages/PostJobs/Companies/RecruiterDetailMain";
import InstituteDetails from "./khojpages/TopInstitute/InstituteDetails";
import SampleCV from "./pages/SampleCV";
import SampleCVdetails from "./pages/SampleCVdetails";
import Vision from "./khojpages/Vision";
import WorkWithUi from "./khojpages/WorkWithUi";
import Guidlines from "./khojpages/Guidlines";
import JobDetailsMain from "./khojpages/JobDetails/JobDetailsMain";
import Information from "./khojpages/Information";
import Blogsingle_v1 from "./pages/Blogsingle_v1";
import AboutCampus from "./pages/AboutCampus";
import AboutCorporate from "./pages/AboutCorporate";
import AboutTalent from "./pages/AboutTalent";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import Blog3 from "./pages/Blog3";
import Blog4 from "./pages/Blog4";
import ResumePdf from "./khojpages/Resume/ResumePdf";
import VerifyAccount from "./components/signin/VerifyAccount";
import preloader from "./assets/images/preloader.gif";
import InstitutionProfile from "./khojpages/ViewProfile/InstitutionProfile";
import CandidInstitutionprofile from "./khojpages/ViewProfile/CandidInstitutionprofile";
import TestAssign from "./khojpages/TestAssign/TestAssign";
import TestAssignModule from "./khojpages/TestAssign/TestAssignModule";

const App = ({ setIsDark }) => {
  const location = useLocation();
  const userType = localStorage.getItem("userType");
  const userUID = localStorage.getItem("userUID");

  const [userData, setUserData] = useState({
    userType: "",
    userUID: "",
  });

  // useEffect(() => {
  //   const userType = localStorage.getItem("userType");
  //   const userUID = localStorage.getItem("userUID");

  //   setUserData({ userType, userUID });
  // }, []);

  const routes = useRoutes([
    {
      path: "/",
      element: (
        <>
          <PrivateRoute
            element={<Home />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Login",
      element: (
        <>
          <PrivateRoute
            element={<Login />}
            isProtected={false}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Account/Confirm",
      element: (
        <>
          <PrivateRoute
            element={<VerifyAccount />}
            isProtected={false}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Register",
      element: (
        <>
          <PrivateRoute
            element={<SignUp />}
            isProtected={false}
            redirectTo="/Home"
          />
        </>
      ),
    },
    { path: "/cv", element: <ResumePdf key={location.key} /> },
    { path: "/Home", element: <Home key={location.key} /> },
    {
      path: "/Forgot-password",
      element: <ForgotPassword key={location.key} />,
    },
    { path: "/About-Us", element: <AboutUs key={location.key} /> },
    {
      path: "/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills",
      element: <Blog1 key={location.key} />,
    },
    {
      path: "/blogs/Crafting-a-Genuine-Learning-Experience-for-Success-in-the-Workplace",
      element: <Blog2 key={location.key} />,
    },
    {
      path: "/blogs/A-Strategic-Approach-to-Closing-Skill-Gaps-in-the-Digital-Age",
      element: <Blog3 key={location.key} />,
    },
    {
      path: "/blogs/How-to-Retain-Your-Top-Performers-by-Building-Inclusive-Workplaces",
      element: <Blog4 key={location.key} />,
    },
    { path: "/Contact", element: <ContactUs key={location.key} /> },
    { path: "/Vision", element: <Vision key={location.key} /> },
    { path: "/Work-with-us", element: <WorkWithUi key={location.key} /> },
    { path: "/Guidelines", element: <Guidlines key={location.key} /> },
    { path: "/Information", element: <Information key={location.key} /> },
    { path: "/Privacy-Policy", element: <PrivacyPolicy key={location.key} /> },
    {
      path: "/Terms-and-Conditions",
      element: <Termsofuse key={location.key} />,
    },
    { path: "/Companies", element: <CompanyList key={location.key} /> },
    { path: "/Institute", element: <Institute key={location.key} /> },
    {
      path: "/SetNewPassword",
      element: <ConfirmPassword key={location.key} />,
    },
    { path: "/job/:JobId", element: <JobDetailsMain key={location.key} /> },
    {
      path: "/Company/:uid",
      element: <CompanyDetailMain key={location.key} />,
    },
    {
      path: "/Recruiter/:uid",
      element: <RecruiterDetailMain key={location.key} />,
    },
    {
      path: "/Institute/:uid",
      element: <InstituteDetails key={location.key} />,
    },
    { path: "/Services/Campus", element: <AboutCampus /> },
    { path: "/Services/Corporate", element: <AboutCorporate /> },
    { path: "/Services/Talent", element: <AboutTalent /> },
    {
      path: "/Change-password",
      element: (
        <>
          <PrivateRoute
            element={<ChangePassword key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Jobs",
      element: (
        <>
          <PrivateRoute
            element={<Searchjobs key={location.key} />}
            isProtected={false}
            redirectTo="/Home"
            // allowedRoles={[ "", "Candidate","Institution",]}
            notallowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    // {
    //   path: "/AllJobs",
    //   element: (
    //     <>
    //       <PrivateRoute
    //         element={<Searchjobs key={location.key} />}
    //         isProtected={false}
    //         redirectTo="/Home"
    //         // allowedRoles={[ "", "Candidate","Institution",]}
    //         notallowedRoles={["Company", "Recruiter"]}
    //       />
    //     </>
    //   ),
    //  },
    {
      path: "/Notifications",
      element: (
        <>
          <PrivateRoute
            element={<Notification key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Settings",
      element: (
        <>
          <PrivateRoute
            element={<Settings key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Saved-jobs",
      element: (
        <>
          <PrivateRoute
            element={<SavedJobs key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Candidate", "Institution"]}
          />
        </>
      ),
    },
    {
      path: "/Applied-jobs",
      element: (
        <>
          <PrivateRoute
            element={<AppliedJobs key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Candidate", "Institution"]}
          />
        </>
      ),
    },
    {
      //  Candidate Resume
      path: "/Resume/Candidate",
      element: (
        <>
          <PrivateRoute
            element={<CandidResume key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Candidate","Company", "Recruiter"]}
          />
        </>
      ),
    },
    { 
      path: "/Resume",
      // path: "/Resume/:CandidateId",
      element: (
        <>
          <PrivateRoute
            element={<CandidResume key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Candidate", "Institution", "Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      // View Resume for Inst candidate 
      path: "/Resume", 
      element: (
        <>
          <PrivateRoute
            element={<CandidResume key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Institution", "Company", "Recruiter"]}
          />
        </>
      ),
    }, 
    {
      path: "/job/Update/:JobId",
      element: (
        <>
          <PrivateRoute
            element={<Editjob key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: "/Candidate/:cnddtUID",
      element: (
        <>
          <PrivateRoute
            element={<UserProfile key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Recruiter/:uid",
      element: (
        <>
          <PrivateRoute
            element={<RecruiterDetailMain key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Institute/Candidate/Update/:CandidateId",
      element: (
        <>
          <PrivateRoute
            element={<UpdateCandidatemain key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Institution"]}
          />
        </>
      ),
    },
    {
      path: "/Resume/:CandidateId/Manage",
      element: (
        <>
          <PrivateRoute
            element={<Resume key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Candidate", "Institution"]}
          />
        </>
      ),
    },
    {
      path: "/Institute/Candidate/Add",
      element: (
        <>
          <PrivateRoute
            element={<EditProfiles key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Institution"]}
          />
        </>
      ),
    },
    {
      path: "/Candidate",
      element: (
        <>
          <PrivateRoute
            element={<Candidate key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/CandidateResume/:CandidateId",
      element: (
        <>
          <PrivateRoute
            element={<CandidResume key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Institute/Candidate/All",
      element: (
        <>
          <PrivateRoute
            element={<BulkProfileResume key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Institution"]}
          />
        </>
      ),
    },
    {
      path: "/job/Add",
      element: (
        <>
          <PrivateRoute
            element={<PostJobs key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: "/Interviews",
      element: (
        <>
          <PrivateRoute
            element={<InterviewAndSchedule key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: "/AssignedTests",
      element: (
        <>
          <PrivateRoute
            element={<TestAssignModule key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: "/Manage-class",
      element: (
        <>
          <PrivateRoute
            element={<ManageBatch />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Institution"]}
          />
        </>
      ),
    },
    {
      path: "/Candidate/All",
      element: (
        <>
          <PrivateRoute
            element={<PeopleSearch key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: "/job/My-Jobs",
      element: (
        <>
          <PrivateRoute
            element={<ViewJobs key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: "/Applications",
      element: (
        <>
          <PrivateRoute
            element={<ApplicantJobs key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
            allowedRoles={["Company", "Recruiter"]}
          />
        </>
      ),
    },
    {
      path: `/${userType}/${userUID}`,
      element: (
        <>
          <PrivateRoute
            element={<ViewProfile key={location.key} />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Institution/:userUid",
      element: (
        <>
          <PrivateRoute
            element={<CandidInstitutionprofile key={location.key} />} 
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    }, 

    { path: "/faqs", element: <Faqs /> },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return routes;
};

// Create Routing

const AppWrapper = () => {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);
  useEffect(() => {
    document.body.style.backgroundColor = isDark ? "#000" : " #F5F5F5";
    document.body.style.color = isDark ? "#f9f7f7" : "#202020";
    const modalElement = document.querySelector(".modal-header"); // Replace with your modal class or ID
    console.log();
    if (modalElement) {
      modalElement.style.backgroundColor = isDark
        ? "#121212 !important"
        : "#ffffff !important";
    }
  }, [isDark]);

  useEffect(() => {
    let linkElement;

    if (isDark) {
      linkElement = document.querySelector(
        `link[href="https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/light.css"]`
      );
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
      linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href =
        "https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/dark.css";
      document.head.appendChild(linkElement);
    } else {
      linkElement = document.querySelector(
        `link[href="https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/dark.css"]`
      );
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
      linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href =
        "https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/light.css";
      document.head.appendChild(linkElement);
    }

    return () => {
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
    };
  }, [isDark]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    document.body.setAttribute("data-theme", isDark ? "dark" : "light");
  }, [isDark]);
  return (
    <>
      {!loading ? (
        <div data-theme={isDark ? "dark" : "light"}>
          <Router>
            <ScrollToTop />
            <App setIsDark={setIsDark} />
          </Router>
        </div>
      ) : (
        <>
          <Preloader />
        </>
      )}
    </>
  );
};

export default AppWrapper;
